import _isEmpty from 'lodash/isEmpty';
import { CUSTOM_TOOLS } from '../../../image/labelling/constants';
import type { GenericAnnotationT, GroupedAnnotationsT, StoreTypeT } from '../../types/types';
import type { AnnotationLabelT } from '../../types/types';
import { STORE_TYPE } from '../../types/types';
import { PENDING_ITEMS_TYPES } from '../pending-items/constants';
const INCOMPLETE_QUESTIONNAIRE = 'Incomplete questionnaire.';
export const groupAnnotationsWithLabel = (annotationList: GenericAnnotationT[]) => {
  const labelAnnotatioMap = {};
  annotationList.forEach((annotation: GenericAnnotationT) => {
    const {
      annotationLabel
    } = annotation;
    if (labelAnnotatioMap[annotationLabel.title]) {
      labelAnnotatioMap[annotationLabel.title].push(annotation);
    } else {
      labelAnnotatioMap[annotationLabel.title] = [annotation];
    }
  });
  return Object.keys(labelAnnotatioMap).map<GroupedAnnotationsT>(label => {
    const annotationListPerLabel = labelAnnotatioMap[label];
    return {
      label: annotationListPerLabel[0].annotationLabel,
      annotationList: annotationListPerLabel
    };
  });
};
export const groupConsensusAnnotationsByAnnotator = (annotationList: GenericAnnotationT[]) => {
  const annotatorAnnotationMap: {
    [key: string]: GenericAnnotationT[];
  } = {};
  annotationList.forEach((annotation: GenericAnnotationT) => {
    const annotator = annotation.metadata?.consensusInfo?.annotator || 'Unknown';
    const annotatorKey = `Annotator ${annotator}`;
    if (annotatorAnnotationMap[annotatorKey]) {
      annotatorAnnotationMap[annotatorKey].push(annotation);
    } else {
      annotatorAnnotationMap[annotatorKey] = [annotation];
    }
  });
  // @ts-expect-error todo(ts-migration) TS2345 Argument of type '(annotatorKey: string) => { label: { title: string; style: AnnotationStyleT; questionnaire: never[]; }; annotationList: GenericAnnotationT[] | undefined; }' is not assignable to para...
  return Object.keys(annotatorAnnotationMap).map<GroupedAnnotationsT>(annotatorKey => {
    const annotationListPerAnnotator = annotatorAnnotationMap[annotatorKey];
    // Create a synthetic label for the annotator group
    return {
      label: {
        title: annotatorKey,
        // @ts-expect-error todo(ts-migration) TS18048 'annotationListPerAnnotator' is possibly 'undefined'.
        style: annotationListPerAnnotator[0].annotationLabel.style,
        questionnaire: []
      },
      annotationList: annotationListPerAnnotator
    };
  });
};
export const getLabelsOfAnnotationType = (annotationList: GenericAnnotationT[], annotationType: string) => {
  const filteredLabels = [];
  if (!annotationList || !annotationType) return filteredLabels;
  return annotationList.reduce((acc, annotation) => {
    if (annotation.annotationType === annotationType) {
      // @ts-expect-error missing null check
      acc.push({
        ...annotation.annotationLabel
      });
    }
    return acc;
  }, []);
};
export const isAnnotationHidden = (annotationList: GenericAnnotationT[], annotationMLList?: GenericAnnotationT[], storeType?: StoreTypeT, annotationConsensusAnnotationsList?: GenericAnnotationT[]): boolean => {
  let isHidden = false;
  if (storeType === STORE_TYPE.ML_ANNOTATION_STORE) {
    if (annotationMLList?.every(mlAnnotationId => mlAnnotationId.hidden)) {
      isHidden = true;
    }
  } else if (storeType === STORE_TYPE.CONSENSUS_ANNOTATION_STORE) {
    if (annotationConsensusAnnotationsList?.every(consensusAnnotation => consensusAnnotation.hidden)) {
      isHidden = true;
    }
  } else {
    if (annotationList.every(annotationId => annotationId.hidden)) {
      isHidden = true;
    }
  }
  return isHidden;
};
export const getPendingAnnotationsFromAnnotationList = (annotationList: GenericAnnotationT[]) => {
  if (!annotationList) return [];
  return annotationList.reduce((acc, annotation) => {
    const {
      annotationLabel,
      metadata,
      id
    } = annotation;
    if (!_isEmpty(annotationLabel.questionnaire) && !Object.keys(metadata?.answers || {}).length) {
      // @ts-expect-error missing null check
      acc.push({
        type: PENDING_ITEMS_TYPES.Questionnaire,
        message: INCOMPLETE_QUESTIONNAIRE,
        annotationId: id,
        annotationLabel: annotationLabel
      });
    }
    return acc;
  }, []);
};
export const isFrameClassificationLabel = (annotationLabel: AnnotationLabelT) => annotationLabel.tools?.includes(CUSTOM_TOOLS.FRAME_CLASSIFICATION);
export const getObjectInstanceLabels = (annotationLabels: AnnotationLabelT[]): AnnotationLabelT[] => {
  return annotationLabels.filter(annotationLabel => !isFrameClassificationLabel(annotationLabel));
};
export const getClassificationLabels = (annotationLabels: AnnotationLabelT[]): AnnotationLabelT[] => {
  return annotationLabels.filter(annotationLabel => isFrameClassificationLabel(annotationLabel));
};
export const hasClassificationLabel = (annotationLabels: AnnotationLabelT[]) => {
  const classificationLabels = getClassificationLabels(annotationLabels);
  return classificationLabels.length > 0;
};